import { Title, Container, Button, RadioImg, FixedBottom } from '@/components'
import styles from './ValidateCarPage.module.scss'
import { useSelector, useDispatch } from 'react-redux'
import {
  fetchPaymentInfo,
  getAreaInfoById,
  getPaymentInfoById,
  getCarsByNumber,
  getSelectedId,
  changeSelectedId,
} from '@/store/slices/stagesSlice/stagesSlice'
import getLinkHref from '@/helpers/getLinkHref'
import { useCallback, useEffect, useState } from 'react';
import { useRouter } from 'next/router'
import { RootState } from '@/store'
import { supportPhoneLink } from '@/constants';

export default function ValidateCarPage({
  number,
  areaId,
  onGoBack,
  onApplyDiscount,
}: {
  number: string
  areaId: string
  onGoBack?: () => void
  onApplyDiscount?: ({ stageId, number }: { stageId: number; number: string }) => void
}) {
  const reduxState = useSelector<RootState, RootState>(state => state)
  const dispatch = useDispatch()
  const router = useRouter()
  const { data } = getCarsByNumber(reduxState, number)
  const isDiscountPage = router.asPath.includes('discount')

  const selectedId = getSelectedId(reduxState)
  const { data: areaInfo } = getAreaInfoById(reduxState, areaId)

  const { loading: getPaymentInfoLoading } = getPaymentInfoById(reduxState, null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(getPaymentInfoLoading)
  }, [getPaymentInfoLoading, setLoading])

  const onFieldChange = (value: string) => {
    dispatch(changeSelectedId({ id: +value ?? null }))
  }

  const _fetchPaymentInfo = useCallback(async () => {
    if (selectedId === null) return
    const notFoundHref = getLinkHref({ type: 'car-number-not-found', data: { id: areaId } })
    const activeSessionHref = getLinkHref({
      type: 'payment',
      data: { areaId, stageId: selectedId },
    })

    await dispatch(
      fetchPaymentInfo({
        id: selectedId,
        number: number,
        onSuccess: () => router.push(activeSessionHref),
        onError: () => router.push(notFoundHref),
      }),
    )
  }, [selectedId, number])

  const handleApplyDiscount = async () => {
    if (onApplyDiscount && selectedId && data) {
      setLoading(true)

      const number = data.find((stage) => stage.id === selectedId)?.number

      number && await onApplyDiscount({ stageId: selectedId, number })

      setLoading(false)
      dispatch(changeSelectedId({ id: null }))
    }
  }

  const submitDisabled = (data || []).every(item => item.id !== selectedId)

  return (
    <section className={styles.section}>
      <Container className={styles.container}>
        <Title>Выберите фото с вашей машиной</Title>

        <div className={styles.radioButtons}>
          {data?.map(item => {
            const { id, photo, number } = item
            const value = `${id}`

            return (
              <div key={id} className={styles.radioButtons__item}>
                <RadioImg
                  name="photo"
                  value={value}
                  checked={selectedId === +value}
                  img={photo}
                  alt={number}
                  onChange={onFieldChange}
                />
              </div>
            )
          })}
        </div>

        <FixedBottom>
          <footer className={styles.footer}>
            <Button
              disabled={submitDisabled}
              onClick={isDiscountPage ? handleApplyDiscount : _fetchPaymentInfo}
              withLoader
              loading={loading}
              className={styles.button}
              background={areaInfo?.customising.button_back_color}
            >
              Продолжить
            </Button>
            {isDiscountPage ? (
              <Button onClick={onGoBack} className={styles.button} isTransparent>
                Назад
              </Button>
            ) : (
              <Button component="a" href={supportPhoneLink} className={styles.button} isTransparent>
                Обратиться в поддержку
              </Button>
            )}
          </footer>
        </FixedBottom>
      </Container>
    </section>
  )
}
